import type { BufferGeometry, ShaderMaterial } from 'three';
import { buildNearDetailLod, NEAR_DETAIL, type NearDetailLod, type NearDetailSpec } from '../mesh/nearDetailLod';
import type { DetailInstances, DetailKind } from './detailSink';

/** LOD1: the joinery in front of the openings within `radius` of the camera and in view (nearDetailLod). */
export const LOD1 = { radius: 250, ...NEAR_DETAIL } as const;

/**
 * The back buildings stand behind the houses, seen from their own courtyard, gang or block: their
 * joinery reaches this far, as the frame budget allows (PLAN Lots).
 */
export const BACK_LOD1 = { radius: 60 } as const;

/** Which openings a LOD holds: its meshes are named `${name}-${kind}`, and it shows them within `radius`. */
export type OpeningLodSpec = NearDetailSpec;

export type OpeningLod = NearDetailLod;

/** One instanced mesh per detail kind, in the instanced painted material. */
export function buildOpeningLod(
  sets: readonly DetailInstances[],
  templates: ReadonlyMap<DetailKind, BufferGeometry>,
  material: ShaderMaterial,
  spec: OpeningLodSpec
): OpeningLod {
  return buildNearDetailLod(sets, templates, material, spec);
}
